import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { resetAppScroll } from '../../utils/scrollToTop';
import { useScrollContainer } from './ScrollContainerContext';

/**
 * Repõe o scroll ao topo quando a rota muda (SPA).
 */
export function ScrollToTop() {
  const { pathname } = useLocation();
  const scrollContainerRef = useScrollContainer();

  useLayoutEffect(() => {
    const scroll = () => resetAppScroll(scrollContainerRef?.current ?? null);

    scroll();
    const frame = requestAnimationFrame(scroll);

    return () => cancelAnimationFrame(frame);
  }, [pathname, scrollContainerRef]);

  return null;
}
